import { SearchResultsDS } from '@src/components/blocks/search-results-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { SearchResultsLegacy, type SearchResultsLegacyProps } from './search-results-legacy'

export type SearchResultsProps = SearchResultsLegacyProps

// NOTE: this switcher is currently only mounted from the legacy subtree
// (`search-results-legacy.tsx`), which itself only renders when the DS gate is OFF — so in
// practice the DS branch below does not fire today (the DS path reaches `SearchResultsDS`
// directly via `SearchResultsSectionDS`). The branch is kept as defensive symmetry with the
// repo's switcher convention, so a future DS parent can mount this component unchanged.
export const SearchResults = (props: SearchResultsProps) => {
  if (shouldUseDesignSystem()) {
    return (
      <SearchResultsDS
        searchQuery={props.searchQuery}
        productCards={props.productCards}
        intersectRef={props.intersectRef}
        isMoreProductsLoading={props.isMoreProductsLoading}
        onResetFilters={props.onResetFilters}
        selectedFilters={props.selectedFilters}
      />
    )
  }
  return <SearchResultsLegacy {...props} />
}
